/* eslint-disable react/jsx-no-target-blank */
import { Button, MuiThemeProvider, TextField } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import { customizerTheme } from 'assets/theme';
import SelectTheme from 'components/Shared/SelectTheme';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { enTheme, ITheme } from 'interfaces/theme';
import React, { PureComponent } from 'react';
import * as rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';
import { themeService } from 'services/themeService';

interface IState {
  themeName: string;
  selectedTheme?: ITheme;
  enSelected?: enTheme;
  isCreatingNewTheme?: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  drawerOptions: {
    overflow: 'scroll',
    position: 'relative',
    height: 'calc(100vh - 35px)'
  },
  container: {
    width: 450,
    height: '100%',
    background: '#FFF'
  },
  titleClose: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 20px 0 20px'
  },
  themeTitle: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: '0 0 40px 0'
  },
  chooseTemplate: {
    fontWeight: 'bold',
    color: '#596375'
  },
  buttonContinue: {
    marginTop: 16,
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '20px 20px 0 20px'
  },
  button: {
    backgroundColor: '#009358',
    color: '#FFF'
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },
  containerProduct: {
    display: 'flex',
    width: '100%',
    padding: '0 !important'
  },
  contentThemes: {
    height: 300,
    display: 'flex',
    padding: '0px 20px',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  instructionsWidget: {
    color: '#F59211',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    padding: '20px 20px 0 20px',
    '& svg': {
      width: 40,
      height: 40,
      fill: '#F59211'
    }
  },
  instructionsLink: {
    color: '#000'
  },
  themeName: {
    margin: '16px 0'
  }
}))
export default class CreateTheme extends PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { themeName: '', selectedTheme: null, enSelected: null, isCreatingNewTheme: false };
  }

  componentDidMount() {
    themeService
      .getSelectedTheme()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe((selectedTheme: ITheme) => {
        this.setState({ selectedTheme });
      });

    themeService.getIsCreating().subscribe(isCreatingNewTheme => this.setState({ isCreatingNewTheme }));
  }

  onClose = () => {
    themeService.setSelectedTheme(null);
    themeService.setIsCreating(false);
    this.setState({ themeName: '', enSelected: null });
  };

  changeType = (enSelected: enTheme) => {
    this.setState({ enSelected });
  };

  createNew = () => {
    themeCustomizerService.setTheme(this.state.enSelected);
    themeCustomizerService.init();
    themeCustomizerService.setData({ themeName: this.state.themeName });
    themeCustomizerService.openCustomizer();

    this.setState({ themeName: '' });
  };

  changeThemeName = (event: any) => {
    this.setState({ themeName: event.target.value });
  };

  render() {
    const { classes } = this.props;
    const { enSelected, themeName, isCreatingNewTheme } = this.state;

    return (
      <Drawer
        anchor="right"
        open={!!isCreatingNewTheme}
        ModalProps={{
          classes: { root: classes.removeBackdrop },
          disableBackdropClick: true,
          onBackdropClick: this.onClose
        }}
        transitionDuration={{ enter: 500, exit: 500 }}
        className={classes.drawerOptions}
      >
        <div className={classes.container}>
          <div className={classes.titleClose}>
            <h2 className={classes.themeTitle}>Novo Tema</h2>
            <span className={classes.closeButton} onClick={this.onClose}>
              <SvgIcon name={'closeIcon'} />
            </span>
          </div>
          <div className={classes.contentThemes}>
            <div className={classes.themeName}>
              <MuiThemeProvider theme={customizerTheme}>
                <TextField
                  id="theme-name"
                  label="1. Dê um nome para seu tema"
                  onChange={this.changeThemeName}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    disableUnderline: true,
                    className: classes.input
                  }}
                  fullWidth
                  value={themeName}
                  margin="normal"
                />
              </MuiThemeProvider>
            </div>
            <p className={classes.chooseTemplate}>2. Selecione um template</p>
            <SelectTheme changeType={this.changeType} />
          </div>
          {enSelected == enTheme.WIDGET && (
            <div className={classes.instructionsWidget}>
              <SvgIcon name="alert" />
              <p>
                Para usar o widget corretamente , siga as instruções&nbsp;
                <a
                  href="https://ajuda.eduzz.com/hc/pt-br/articles/4402962721307-Como-configurar-o-Checkout-Widget-"
                  target="_blank"
                  className={classes.instructionsLink}
                >
                  clicando aqui
                </a>
              </p>
            </div>
          )}
          <div className={classes.buttonContinue}>
            <Button
              onClick={this.createNew}
              classes={{ root: classes.button }}
              variant="contained"
              color="primary"
              disabled={!enSelected || themeName.trim().length < 1}
            >
              Continuar
            </Button>
          </div>
        </div>
      </Drawer>
    );
  }
}
